module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_c('ul', [_vm._l((_vm.links), function(item) {
    return [(item.value !== 'store') ? _c('li', {
      key: item.value,
      staticClass: "links-item",
      class: _vm.current === item.value && 'active',
      on: {
        "click": function($event) {
          return _vm.handleClick(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]) : _vm._e(), _vm._v(" "), (item.value === 'store' && _vm.system_mode === 'platform') ? _c('li', {
      key: item.value,
      staticClass: "links-item",
      class: _vm.current === item.value && 'active',
      on: {
        "click": function($event) {
          return _vm.handleClick(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]) : _vm._e()]
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7c8d50f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8d50f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_links/comps/tabs.vue
// module id = 2854
// module chunks = 0